import getLobbies from "./getLobbies"
import createLobby from "./createLobby"
import joinLobby from "./joinLobby"
import findLobby from "./findLobby"
import leaveRoom from "./leaveRoom"
import startWebSocket from "./startWebSocket"

// This is needed for the slice to parse and fullfill the actions when
// the thunks are successfully processed + handling error/loading state
const allThunks = { getLobbies, createLobby, joinLobby, findLobby, leaveRoom, startWebSocket }
export default allThunks

// This export is to improve the readability of the code when importing the actions
// from the components that use the thunks.
const getLobbiesThunk = getLobbies.thunk
const createLobbyThunk = createLobby.thunk
const joinLobbyThunk = joinLobby.thunk
const findLobbyThunk = findLobby.thunk
const leaveRoomThunk = leaveRoom.thunk
const startWebSocketThunk = startWebSocket.thunk
export {
  getLobbiesThunk as getLobbies,
  createLobbyThunk as createLobby,
  joinLobbyThunk as joinLobby,
  findLobbyThunk as findLobby,
  leaveRoomThunk as leaveRoom,
  startWebSocketThunk as startWebSocket,
}
